export class NewMessageRequest {

  constructor(public name: string,
              public message: string,
              public startDate: Date,
              public endDate: Date,
              public active: boolean) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/banner/new-message-request.ts